import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppIcon from "./components/WhatsAppIcon";
import Home from "./pages/Home";
import CorporalStetic from "./pages/CorporalStetic";
import FacialStetic from "./pages/FacialStetic";
import AboutUs from "./pages/AboutUs";
import BookingPage from "./pages/BookingPage";
import SalonPage from "./pages/SalonPage";

import Login from "./login/Login";
import UpdatePasswordPage from "./login/UpdatePasswordPage";
import AdminPanel from "./login/Administrador/AdminPanel";
import Configurations from "./login/Administrador/AdminPanel/Configurations";
import EnterprisePanel from "./login/Empresa/EnterprisePanel";
import { ProtectedRoute } from "./context/AuthContext";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppLayout = () => {
  const { pathname } = useLocation();

  const hidePublicLayout =
    pathname === "/iniciar-sesion" ||
    pathname === "/actualizar-clave" ||
    pathname.startsWith("/admin-panel");

  return (
    <>
      <ScrollToTop />

      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {!hidePublicLayout && <Navbar />}

        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tratamientos/estetica-corporal" element={<CorporalStetic />} />
            <Route path="/tratamientos/estetica-facial" element={<FacialStetic />} />
            <Route path="/acerca-de-nosotros" element={<AboutUs />} />
            <Route path="/peluqueria" element={<SalonPage />} />
            <Route path="/agendar-cita" element={<BookingPage />} />
            <Route path="/iniciar-sesion" element={<Login />} />
            <Route path="/actualizar-clave" element={<ProtectedRoute allowedRoles={["super_admin", "admin", "staff"]}><UpdatePasswordPage /></ProtectedRoute>} />
            <Route path="/admin-panel" element={<ProtectedRoute allowedRoles={["super_admin", "admin", "staff"]}><AdminPanel /></ProtectedRoute>} />
            <Route path="/admin-panel/configuracion" element={<ProtectedRoute allowedRoles={["super_admin", "admin", "staff"]}><Configurations /></ProtectedRoute>} />
            <Route path="/admin-panel/empresa" element={<ProtectedRoute allowedRoles={["super_admin", "admin", "staff"]}><EnterprisePanel /></ProtectedRoute>} />
          </Routes>
        </main>

        {!hidePublicLayout && <Footer />}
      </div>

      {!hidePublicLayout && <WhatsAppIcon />}
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;